import { type AssessmentCollection } from "@/api/assessment/types";

export const standaloneDraftAssessmentUrl = (
  workspaceId: string,
  collectionId: string,
  assessmentId: string
) =>
  `/w/${workspaceId}/assessments/${collectionId}/a/${assessmentId}/introduction`;

export const twoStageDraftAssessmentUrl = (
  workspaceId: string,
  collectionId: string
) => `/w/${workspaceId}/assessments/${collectionId}/two-stage-builder`;

export const draftAssessmentUrl = ({
  workspaceId,
  collectionId,
  collectionType,
  assessmentId,
}: {
  workspaceId: string;
  collectionId: string;
  collectionType: AssessmentCollection["collectionType"];
  assessmentId?: string;
}) => {
  if (collectionType !== "TWO_STAGE" && assessmentId) {
    return standaloneDraftAssessmentUrl(
      workspaceId,
      collectionId,
      assessmentId
    );
  }

  if (collectionType !== "TWO_STAGE" && !assessmentId) {
    return collectionListUrl(workspaceId);
  }

  return twoStageDraftAssessmentUrl(workspaceId, collectionId);
};

export const collectionListUrl = (workspaceId: string) =>
  `/w/${workspaceId}/assessments`;

export const collectionOverviewUrl = (
  workspaceId: string,
  collectionId: string
) => `/w/${workspaceId}/assessments/${collectionId}/overview`;

export const collectionVersionHistoryUrl = (
  workspaceId: string,
  collectionId: string
) => `/w/${workspaceId}/assessments/${collectionId}/overview/history`;
